module.exports = __webpack_public_path__ + "img/Khainza-Willian.656fc483.jpg";